<app-tabla
  [totalCount]="totalCount"
  [datos]="auditorias"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [(query)]="query"
  [filtros]="filtros"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [emptyState]="{ title: 'Todavía no hay auditorías' }"
></app-tabla>
